import React from "react";
import DefaultPrivacyPolicy from "src/components/feature/PrivacyPolicy";

const PrivacyPolicy = () => {
  return <DefaultPrivacyPolicy />;
};

export default PrivacyPolicy;
